import { Translation } from "@/data/lang";

import { TabProps } from "ui/core/horizontal-tab";

export const mediaCenterPathnames = [
  "/website-tutorials",
  "/trading-courses",
  "/live-trading-sessions",
  "/weekly-market-analysis",
];

const mediaCenterPathnameMap = Object.fromEntries(
  mediaCenterPathnames.map((path) => [path, path])
);

export const getCategoryTabs = ({ t }: { t: Translation }): TabProps[] => [
  {
    name: t.mediaCenter.websiteTutorials,
    key: mediaCenterPathnameMap["/website-tutorials"],
    label: "Website Tutorials",
  },
  {
    name: t.mediaCenter.tradingCourses,
    key: mediaCenterPathnameMap["/trading-courses"],
    label: "Trading Courses",
  },
  {
    name: t.mediaCenter.liveTradingSession,
    key: mediaCenterPathnameMap["/live-trading-sessions"],
    label: "Live Trading Sessions",
  },
  {
    name: t.mediaCenter.weeklyMarketAnalysis,
    key: mediaCenterPathnameMap["/weekly-market-analysis"],
    label: "Weekly Market Analysis",
  },
];
